import React from "react";
import styled from "styled-components";
import { DOLLAR_COINS } from "@shared/common/constants";
import TextWithPrecision from "common/Text/TextWithPrecision";
import { getNewLookTokens } from "common/NewLook/tokens.ts";
import { PrecisionConfig, PrecisionType } from "@shared/types";
import { RootState } from "app/store";

interface StatAmountProps {
  text?: number | string;
  coin?: string;
  precision?: number;
  precisionType?: PrecisionType;
  precisionConfig?: PrecisionConfig;
  precisionSelector?: (state: RootState) => PrecisionConfig | {} | undefined;
}

/**
 * A figure in a key-figure strip, without a coin icon: dollar-pegged quotes
 * read "$1,234", any other coin reads "0.0213 BTC" with the coin as a small
 * muted suffix.
 */
const StatAmount = ({
  text,
  coin,
  precision,
  precisionType,
  precisionConfig,
  precisionSelector,
}: StatAmountProps) => {
  const isDollar = !!coin && DOLLAR_COINS.includes(coin.toUpperCase());
  return (
    <>
      {isDollar && "$"}
      <TextWithPrecision
        text={text}
        precision={precision}
        precisionType={precisionType}
        precisionCoin={coin}
        precisionConfig={precisionConfig}
        precisionSelector={precisionSelector}
      />
      {coin && !isDollar && <Unit>{coin}</Unit>}
    </>
  );
};

export default StatAmount;

const Unit = styled.span`
  && {
    margin-left: 4px;
    font-size: 12.5px;
    font-weight: 400;
    color: ${(p) => getNewLookTokens(p.theme).muted};
  }
`;
